$('.fake-select .selected-option').on('click', function() {
    $(this).parents('.fake-select').toggleClass('open-select');
  });

  $('.fake-select').on('click', '.options-wrapper div', function(e) {
    e.preventDefault();
    e.stopPropagation();

    var $contactFormSelectId = $('#ClientTypeSelect');

    $(this).parents('.fake-select').removeClass('open-select');
    $(this).parents('.fake-select').find('.options-wrapper div').removeClass('selected');
    $(this).addClass('selected');

    //Select the size in the real select
    var fakeVariantValue = $(this).attr('data-value');
    $(this).parents('.fake-select').find('.selected-option span').html(fakeVariantValue);
    $(this).parents('.fake-select').siblings('.client-type__select').val(fakeVariantValue).change();

    if ($contactFormSelectId) {
        $contactFormSelectId.val(fakeVariantValue);
    }
 });
